module.exports = __webpack_public_path__ + "static/media/NeoLogo.80beb3ca.png";